<template>
<div ref="pay-card-otp" id="pay-card-otp" class="opt-content-wrapper pay-pane active py-3 px-4">

    <p v-html="msg" v-if="!loading"></p>

    <div class="modal-body pb-1">
        <div class="row m-0">
            <div v-if="loading">
                <div class="my-2 animate slideInTop" style="background:url(/loading-black.svg) no-repeat center center;height:50px;"></div>
                <p>Please wait, processing transaction</p>
            </div>
            <div v-else>
                <div class="col-12 px-0">
                    <div class="form-group ">
                        <form  class="pay-otp-code" @submit.prevent="submitOtp">
                            <input :type="showNum ? 'number' : 'text'" class="form-control no-label text-center" @keyup.enter="submitOtp" v-model="trx_otp" id="otpInput" ref="otpInput" maxlength="14" autocomplete="off" minlength="4" autofocus required @focus="isFocus = true" @blur="isFocus = false" :style="{ borderColor: (isFocus ? appColor : '#e4e4e4')  }" />
                            <span class="invalid-feedback" :style="(errors.trx_otp) ? 'display : inline' : ''">{{ otp_error_message }}</span>
                        </form>
                    </div>
                </div>

                <div class="col-12 px-0">
                    <div v-if="!loading" class="form-group text-center mb-0 text-center">
                        <a href="javascript:void(0)" class="text-tiny" @click.prevent="tryAgain">&larr; Go back</a>
                    </div>
                    <div class="form-group mb-0 mt-3">
                        <button type="submit" class="btn app-bg-color" :style="{ background : appColor }" ref="btnActionSendOtp" id="btnActionSendOtp" @click.prevent="submitOtp" @keyup.enter="submitOtp">Make Payment</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';

export default {
    name: 'otp',
    props: ['msg', 'status', 'appColor'],
    created() {
        let message = this.msg.toLowerCase()
        if(message.includes('name'))
            this.showNum = false
        else 
            this.showNum = true;

    },
    watch: {
        trx_otp(newVal) {
            if (this.errors.trx_otp) {
                this.errors.trx_otp = false;
                this.trx_otp = newVal;
            }
        },
        isFocus(newVal) {
            if (newVal)
                this.focusColor = this.appColor

        }
    },
    data() {
        return {
            trx_otp: '',
            otp_error_message: '',
            isFocus: true,
            focusColor: '',
            showNum: true,
            loading: false,
            errors: {
                trx_otp: false,
            }
        }
    },
    methods: {
        tryAgain() {
            const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef()}`; 
            this.$store.dispatch('transRef', newRef);
            // this.$store.dispatch('transRef', Date.now() + (Math.floor(Math.random() * 1000)).toString());
            this.$store.dispatch('isFailed', true);
            this.$parent.changeComponent('CardPayment');
            this.loading = false;
        },
        submitOtp() {
            if (this.trx_otp.length <= 0) {
                this.errors.trx_otp = true;
                this.otp_error_message = "Please supply OTP code.";
                this.$refs.otpInput.focus();
                return;
            }

            this.loading = true;

            var payload = {
                otp: this.trx_otp,
                transRef: this.$store.state.transRef,
            };

            if (this.$store.state.isFailed)
                payload.parentTransRef = this.$store.state.parentTransRef


            // Append Transaction Ref into transaction_desc
            // Eg. 23489490AB_Payment for airtime purchase
            payload.transaction.transaction_desc = `${payload.transaction.transaction_ref}_${payload.transaction.transaction_desc}`;

            axios.post(this.baseApiUrl + "v1/otp", {
                    data: this.$generateToken(payload)
                }, {
                    Authorization: 'bearer ' + this.$store.state.payload.api_key
                }).then(response => {
                    if (response.status === 200) {
                        var res = response.data;
                        window.raw = JSON.stringify(res.data);

                        if (res.code == "00") {
                            this.loading = false;
                            
                            // Check if user set close_popup for card to onSuccess
                            let payload = this.$store.state.payload
                            if(payload.options && payload.options.close_popup && payload.options.close_popup.card == 'onSuccess'){
                                let onepipeResponse = res.data
                                delete onepipeResponse.data.client_info;
                                delete onepipeResponse.data.paymentoptions;
                                delete onepipeResponse.data.message;
                                delete onepipeResponse.data.status;
                                this.$parent.continueToMerchant({
                                    message: onepipeResponse.message,
                                    status: onepipeResponse.status,
                                    data: onepipeResponse.data,
                                });
                                return;
                            }

                            this.$parent.changeComponent('Status', {
                                transRef: this.$store.state.transRef,
                                type: 'Successful',
                                data: res.data,
                                message: res.message
                            });
                        } else {
                            this.loading = false;
                            window.failedFromStart = false;
                            window.failedFromStartMessage = res.message;
                            this.$router.push('warning');
                        }
                    } else {
                        window.failedFromStart = false;
                        this.$router.push('warning');
                    }
                })
                .catch(error => {
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('warning');
                })
        }
    }
};
</script>

<style scoped>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>
